setTimeout(function() {
  // 名入れ
  if ($('button.pplr-c-button').length) {
    $('button.pplr-c-button').attr('data-ga-event-label', 'product-detail-print-name-btn').addClass('gaClick')
  }
  if ($('.pplr_ex_inner button.pplr-btn').length) {
    $('.pplr_ex_inner button.pplr-btn').attr('data-ga-event-label', 'product-detail-print-name-add-cart-btn').addClass('gaClick')
  }

  // 店舗在庫
  if ($('.iia-expandable .iia-header').length) {
    $('.iia-expandable .iia-header').attr('data-ga-event-label', 'product-detail-store-inventory-open').addClass('gaClick')
  }
  if ($('.iia-note a').length) {
    $('.iia-note a').attr('data-ga-event-label', 'product-detail-store-inventory-link').addClass('gaClick')
  }
}, 1000)
